<template>
    <div class="modal fade" id="modalSesionMaternidad" tabindex="-1" role="dialog" aria-labelledby="modalSesionMaternidadLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header bg-light">
                    <h5 class="modal-title" id="modalSesionMaternidadLabel">{{ selectedSesion.titulo }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div v-if="selectedSesion.id">

                        <div class="mb-3">
                            <label class="font-weight-bold">Temáticas</label>
                            <div class="border rounded p-2 bg-light" style="white-space: pre-line">
                                {{ selectedSesion.tematica }}
                            </div>
                        </div>

                        <div class="mb-3">
                            <label class="font-weight-bold">Ejercicios</label>
                            <div class="border rounded p-2 bg-light" style="white-space: pre-line">
                                {{ selectedSesion.ejercicios }}
                            </div>
                        </div>

                        <!-- Fecha, Trimestre y Realizada -->
                        <div class="row">
                            <div class="col-md-4 mb-3">
                                <label class="font-weight-bold">Fecha de la sesión <span class="text-danger">*</span></label>
                                <input
                                    type="date"
                                    class="form-control"
                                    :class="{ 'is-invalid': $v.selectedSesion.fecha.$error }"
                                    v-model="selectedSesion.fecha"
                                    :disabled="finalizada === 'S'"
                                >
                                <div v-if="$v.selectedSesion.fecha.$error" class="invalid-feedback">
                                    La fecha es requerida.
                                </div>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="font-weight-bold">Trimestre <span class="text-danger">*</span></label>
                                <select
                                    class="form-control"
                                    :class="{ 'is-invalid': $v.selectedSesion.trimestre.$error }"
                                    v-model="selectedSesion.trimestre"
                                    :disabled="finalizada === 'S'"
                                >
                                    <option :value="null" disabled>Seleccione...</option>
                                    <option :value="1">Trimestre 1</option>
                                    <option :value="2">Trimestre 2</option>
                                    <option :value="3">Trimestre 3</option>
                                </select>
                                <div v-if="$v.selectedSesion.trimestre.$error" class="invalid-feedback">
                                    El trimestre es requerido.
                                </div>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="font-weight-bold d-block">¿Sesión realizada? <span class="text-danger">*</span></label>
                                <div class="custom-control custom-radio custom-control-inline mt-1">
                                    <input
                                        type="radio"
                                        id="realizadaSi"
                                        class="custom-control-input"
                                        :class="{ 'is-invalid': $v.selectedSesion.realizada.$error }"
                                        v-model="selectedSesion.realizada"
                                        value="S"
                                        :disabled="finalizada === 'S'"
                                    >
                                    <label class="custom-control-label text-success font-weight-bold" for="realizadaSi">Sí</label>
                                </div>
                                <div class="custom-control custom-radio custom-control-inline mt-1">
                                    <input
                                        type="radio"
                                        id="realizadaNo"
                                        class="custom-control-input"
                                        :class="{ 'is-invalid': $v.selectedSesion.realizada.$error }"
                                        v-model="selectedSesion.realizada"
                                        value="N"
                                        :disabled="finalizada === 'S'"
                                    >
                                    <label class="custom-control-label text-danger font-weight-bold" for="realizadaNo">No</label>
                                </div>
                                <div v-if="$v.selectedSesion.realizada.$error" class="text-danger small mt-1">
                                    Debe indicar si la sesión fue realizada o no.
                                </div>
                            </div>
                        </div>

                        <!-- Observaciones -->
                        <div class="mb-3">
                            <label class="font-weight-bold">
                                Observaciones <span class="text-danger">*</span>
                            </label>
                            <textarea
                                class="form-control"
                                :class="{ 'is-invalid': $v.selectedSesion.observaciones.$error }"
                                rows="4"
                                v-model="selectedSesion.observaciones"
                                :disabled="finalizada === 'S'"
                                placeholder="Escriba aquí las observaciones de la sesión..."
                            />
                            <div v-if="$v.selectedSesion.observaciones.$error" class="invalid-feedback">
                                Las observaciones son requeridas.
                            </div>
                        </div>

                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-light btn-sm" data-dismiss="modal"> <i class="fa fa-times"></i>Cerrar</button>
                    <button
                        v-if="finalizada !== 'S'"
                        type="button"
                        class="btn btn-success btn-sm"
                        @click="guardar"
                    >
                        <i class="fas fa-save fa-fw"></i> Guardar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { saveSesion } from '@/services/cursoMaternidadService';
import $ from 'jquery';
import Swal from 'sweetalert2';
import { required } from 'vuelidate/lib/validators';
import dayjs from 'dayjs';

export default {
    name: 'ModalSesion',
    props: {
        idHistoria: {
            required: true
        },
        idEmbarazo: {
            required: true
        },
        finalizada: {
            type: String,
            default: 'N'
        }
    },
    data() {
        return {
            selectedSesion: {
                realizada: null,
                fecha: '',
                trimestre: null,
                observaciones: ''
            }
        };
    },
    validations() {
        return {
            selectedSesion: {
                realizada: { required },
                fecha: { required },
                trimestre: { required },
                observaciones: { required }
            }
        };
    },
    methods: {
        open(sesion) {
            this.selectedSesion = {
                ...sesion,
                realizada: sesion.realizada || null,
                fecha: sesion.fecha || dayjs().format('YYYY-MM-DD'),
                trimestre: sesion.trimestre || null,
                observaciones: sesion.observaciones || ''
            };
            this.$v.$reset();
            $('#modalSesionMaternidad').modal('show');
        },
        async guardar() {
            if (!this.selectedSesion.id) return;

            this.$v.$touch();
            if (this.$v.$invalid) return;

            try {
                this.LoaderSpinnerShow();
                const data = {
                    id_historia: this.idHistoria,
                    id_embarazo: this.idEmbarazo,
                    id_sesion: this.selectedSesion.id,
                    realizada: this.selectedSesion.realizada,
                    fecha: this.selectedSesion.fecha,
                    trimestre: this.selectedSesion.trimestre,
                    observaciones: this.selectedSesion.observaciones
                };

                const response = await saveSesion(data);
                this.LoaderSpinnerHide();

                if (response.data.success) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Éxito',
                        text: response.data.message || 'Sesión guardada correctamente.',
                        timer: 1500,
                        showConfirmButton: false
                    });
                    $('#modalSesionMaternidad').modal('hide');
                    this.$emit('saved-session');
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: response.data.message || 'No se pudo guardar la sesión.'
                    });
                }
            } catch (error) {
                this.LoaderSpinnerHide();
                console.error(error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Ocurrió un error inesperado al guardar la sesión.'
                });
            }
        }
    }
};
</script>
